export default function (width, height) {
  return {
    props: {
      width: {
        type: String,
        default: width
      },
      height: {
        type: String,
        default: height || width
      },
      xmlns: {
        type: String,
        default: 'http://www.w3.org/2000/svg'
      }
    },
    computed: {
      iconClassName () {
        return 'hippolyte-icon_' + this.$options.name.split('.').pop()
      }
    }
  }
}
